import { render } from "./wangEditer.vue?vue&type=template&id=2526e42e&scoped=true"
import script from "./wangEditer.vue?vue&type=script&lang=js"
export * from "./wangEditer.vue?vue&type=script&lang=js"

import "./wangEditer.vue?vue&type=style&index=0&id=2526e42e&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2526e42e"]])

export default __exports__